// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3iE9h","messages":"Chat_messages__csYxQ","dateDivider":"Chat_dateDivider__s-K9T"};